import React, { useCallback } from 'react';
import { Alert } from 'reactstrap';

import OrderAlertTypes from '../../types/order/OrderAlert';

const useAlerts = ({ generalAlerts = [], errorAlerts = [] }) => {
  const renderErrorAlerts = useCallback(() => {
    return errorAlerts.map((alert, index) => (
      <Alert key={index} className={`${OrderAlertTypes.DANGER}`} color="danger">
        <div dangerouslySetInnerHTML={{ __html: alert.message }} />
      </Alert>
    ));
  }, [errorAlerts]);

  const renderGeneralAlerts = useCallback(() => {
    return generalAlerts.map((alert, index) => {
      let content;

      switch (alert.type) {
        case OrderAlertTypes.SUCCESS:
          content = (
            <Alert
              key={index}
              color="success"
              className={`${OrderAlertTypes.SUCCESS}`}
            >
              <div dangerouslySetInnerHTML={{ __html: alert.message }} />
            </Alert>
          );
          break;
        case OrderAlertTypes.INFO:
          content = (
            <Alert
              key={index}
              color="info"
              className={`${OrderAlertTypes.INFO}`}
            >
              <div dangerouslySetInnerHTML={{ __html: alert.message }} />
            </Alert>
          );
          break;
        case OrderAlertTypes.WARNING:
          content = (
            <Alert
              key={index}
              color="warning"
              className={`${OrderAlertTypes.WARNING}`}
            >
              <div dangerouslySetInnerHTML={{ __html: alert.message }} />
            </Alert>
          );
          break;
        // Include danger because there might be general danger alerts
        case OrderAlertTypes.DANGER:
          content = (
            <Alert
              key={index}
              color="danger"
              className={`${OrderAlertTypes.DANGER}`}
            >
              <div dangerouslySetInnerHTML={{ __html: alert.message }} />
            </Alert>
          );
          break;
        default:
          content = null;
          break;
      }

      return content;
    });
  }, [generalAlerts]);

  return { renderErrorAlerts, renderGeneralAlerts };
};

export default useAlerts;
